'use client';

import clsx from 'clsx';
import { useParams } from 'next/navigation';
import { FC, Fragment } from 'react';
import { LOCALES } from 'root/src/envVariables';
import { IconSVG } from 'atoms/IconSVG';
import { Link } from 'atoms/Link/Link';
import { Body } from 'atoms/Typography/Typography';
import styles from './LanguageSelector.module.css';

export const LanguageSelector: FC<{ className?: string }> = ({ className }) => {
  const { locale } = useParams();

  if (LOCALES.length <= 1) {
    return null;
  }
  type Icon = 'nlFlag' | 'frFlag';
  const localeConfig = LOCALES.reduce<
    Record<string, { icon: Icon; label: string }>
  >((memo, lang) => {
    const [_lang] = lang.split('-');
    memo[_lang] = { icon: `${_lang}Flag` as Icon, label: _lang.toUpperCase() };
    return memo;
  }, {});

  return (
    <div className={clsx(styles.container, className)}>
      {LOCALES.map((loc, index) => (
        <Fragment key={loc}>
          <Link
            className={clsx(
              styles.link,
              (locale as string) === loc && styles.active,
            )}
            href={'/'}
            locale={loc}
          >
            <IconSVG type={localeConfig[loc].icon} className={styles.flag} />
            <Body type="md" tag="span" className={styles.label}>
              {localeConfig[loc].label}
            </Body>
          </Link>
          {index < LOCALES.length - 1 && (
            <Body type="md" tag="span" className={styles.separator}>
              |
            </Body>
          )}
        </Fragment>
      ))}
    </div>
  );
};
